export default __webpack_public_path__ + "static/media/aniamarker.20d902ae.svg";